import PaymentCheckoutPage from './PaymentCheckoutPage'

export default PaymentCheckoutPage
